import urls from './urls'
import Service from '@/utils/fetch'

// 获取纪念堂列表
export function _findSpaceList(data) {
  return Service({
    url: urls.findSpaceList,
    data
  })
}

//获取告别厅列表-全部
export function _findAllList(data) {
  return Service({
    url: urls.findAllList,
    data
  })
}

//获取单位信息列表（全部）
export function _findAppInfoAll(data) {
  return Service({
    url: urls.findAppInfoAll,
    data
  })
}

//新建纪念堂信息
export function _addSpace(data) {
  return Service({
    url: urls.addSpace,
    data
  })
}

//新建/编辑告别会
export function _addOrEdit(data,dmId) {
  return Service({
    url: urls.addOrEdit,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//获取纪念堂日志列表
export function _findLog(data,dmId) {
  return Service({
    url: urls.findLog,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//获取纪念堂详情
export function _findById(data,dmId) {
  return Service({
    url: urls.findById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//获取纪念堂详情-成员列表
export function _findUserDmRelationById(data) {
  return Service({
    url: urls.findUserDmRelationById,
    data
  })
}

//获取纪念堂详情-留言列表
export function _findSignInById(data) {
  return Service({
    url: urls.findSignInById,
    data
  })
}


//获取背景模板列表
export function _findAllBgTemplate(data) {
  return Service({
    url: urls.findAllBgTemplate,
    data
  })
}

//获取背景模板列表V2
export function _findAllBgTemplateV2(data) {
  return Service({
    url: urls.findAllBgTemplateV2,
    data
  })
}

//获取音乐模板列表
export function _findAllMusicTemplate(data) {
  return Service({
    url: urls.findAllMusicTemplate,
    data
  })
}


//获取纪念堂日志列表
export function _findDeadLog(data) {
  return Service({
    url: urls.findDeadLog,
    data
  })
}


//编辑纪念堂陵园使用信息
export function _editCemeteryById(data,dmId) {
  return Service({
    url: urls.editCemeteryById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}


//编辑纪念堂信息
export function _editById(data,dmId) {
  return Service({
    url: urls.editById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}


//纪念堂编辑权限申请
export function _editUpdateStateById(data,dmId) {
  return Service({
    url: urls.editUpdateStateById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//纪念堂上传权限申请
export function _editUploadStateById(data,dmId) {
  return Service({
    url: urls.editUploadStateById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//访问码冻结管理
export function _editVisitorFrozenById(data) {
  return Service({
    url: urls.editVisitorFrozenById,
    data
  })
}

//纪念堂冻结管理
export function _editSpaceFrozenById(data,dmId) {
  return Service({
    url: urls.editSpaceFrozenById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//获取文件地址数据流
export function _getUrlDataSource(data) {
  return Service({
    url: urls.getUrlDataSource,
    data
  })
}

//纪念堂操作权限取消
export function _cancelUpdateStateById(data) {
  return Service({
    url: urls.cancelUpdateStateById,
    data
  })
}

//获取地址响应码
export function _getUrlConnectionCode(data) {
  return Service({
    url: urls.getUrlConnectionCode,
    data
  })
}


//获取OSS上传文件状态
export function _getOssFileState(data) {
  return Service({
    url: urls.getOssFileState,
    data
  })
}

//纪念堂上传权限取消
export function _cancelUploadStateById(data,dmId) {
  return Service({
    url: urls.cancelUploadStateById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 编辑纪念堂上传信息
export function _editUploadById(data,dmId) {
  return Service({
    url: urls.editUploadById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 获取纪念堂上传列表
export function _findUploadByDmId(data,dmId) {
  return Service({
    url: urls.findUploadByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 添加纪念堂日志复制
export function _saveLog(data,dmId) {
  return Service({
    url: urls.saveLog,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 编辑逝者姓名
export function _editDeadNameById(data) {
  return Service({
    url: urls.editDeadNameById,
    data
  })
}

export function _getWxPayOrder(data) {
  return Service({
    url: urls.getWxPayOrder,
    data
  })
}

// 删除上传文件
export function _delUploadById(data,dmId) {
  return Service({
    url: urls.delUploadById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 删除上传文件
export function _findPhotoCategory(data,dmId) {
  return Service({
    url: urls.findPhotoCategory,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 相册-新建/编辑
export function _addOrEditPhotoCategory(data,dmId) {
  return Service({
    url: urls.addOrEditPhotoCategory,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 相册-删除
export function _delPhotoCategory(data,dmId) {
  return Service({
    url: urls.delPhotoCategory,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-空间照片列表
export function _findPhotoByDmId(data,dmId) {
  return Service({
    url: urls.findPhotoByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-相册照片列表
export function _findPhotoByCategoryId(data,dmId) {
  return Service({
    url: urls.findPhotoByCategoryId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-上传相册照片
export function _addPhotoByCategoryId(data,dmId) {
  return Service({
    url: urls.addPhotoByCategoryId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-删除
export function _delPhotoById(data,dmId) {
  return Service({
    url: urls.delPhotoById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-修改备注
export function _editPhotoRemark(data,dmId) {
  return Service({
    url: urls.editPhotoRemark,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-互换位置
export function _editPhotoPosition(data,dmId) {
  return Service({
    url: urls.editPhotoPosition,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//相册-迁移列表
export function _findMovePhotoCategory(data,dmId) {
  return Service({
    url: urls.findMovePhotoCategory,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//照片-迁移
export function _movePhoto(data,dmId) {
  return Service({
    url: urls.movePhoto,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//纪念堂成员总数
export function _getUserCount(data) {
  return Service({
    url: urls.getUserCount,
    data
  })
}

//照片-拖动排序
export function _dragPhoto(data,dmId) {
  return Service({
    url: urls.dragPhoto,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

//投屏-获取视频
export function _getCoverVideo(data) {
  return Service({
    url: urls.getCoverVideo,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//纪念堂详情-获取APP认领码
export function _getClaimCodeUrl(data) {
  return Service({
    url: urls.getClaimCodeUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//纪念堂详情-获取认领码
export function _getClaimCodeUrlAll(data) {
  return Service({
    url: urls.getClaimCodeUrlAll,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//人生相册-获取信息
export function _getLifeAlbumByDmId(data, dmId) {
  return Service({
    url: urls.getLifeAlbumByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取照片
export function _findLifeAlbumPhotoAllByDmId(data, dmId) {
  return Service({
    url: urls.findLifeAlbumPhotoAllByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-添加照片
export function _addLifeAlbumPhotoByDmId(data, dmId) {
  return Service({
    url: urls.addLifeAlbumPhotoByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-拖动照片
export function _draggableLifeAlbumPhoto(data, dmId) {
  return Service({
    url: urls.draggableLifeAlbumPhoto,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-删除照片
export function _delLifeAlbumPhotoByIds(data, dmId) {
  return Service({
    url: urls.delLifeAlbumPhotoByIds,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取背景模板
export function _findLifeAlbumTemplateBg(data, dmId) {
  return Service({
    url: urls.findLifeAlbumTemplateBg,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取音乐模板
export function _findLifeAlbumTemplateMusic(data, dmId) {
  return Service({
    url: urls.findLifeAlbumTemplateMusic,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取字幕模板1-人生角色
export function _findLifeAlbumSubtitle1(data, dmId) {
  return Service({
    url: urls.findLifeAlbumSubtitle1,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取字幕模板2-人才类型
export function _findLifeAlbumSubtitle2(data, dmId) {
  return Service({
    url: urls.findLifeAlbumSubtitle2,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取字幕模板3-天命
export function _findLifeAlbumSubtitle3(data, dmId) {
  return Service({
    url: urls.findLifeAlbumSubtitle3,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-添加人生相册
export function _addLifeAlbumByDmId(data, dmId) {
  return Service({
    url: urls.addLifeAlbumByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-添加人生相册-监听是否完成
export function _addLifeAlbumListener(data, dmId) {
  return Service({
    url: urls.addLifeAlbumListener,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-清空人生相册
export function _cleanLifeAlbumByDmId(data, dmId) {
  return Service({
    url: urls.cleanLifeAlbumByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-更新当前状态
export function _updateLifeAlbumStateByDmId(data, dmId) {
  return Service({
    url: urls.updateLifeAlbumStateByDmId,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-获取照片相框
export function _findLifeAlbumPhotoFrameById(data, dmId) {
  return Service({
    url: urls.findLifeAlbumPhotoFrameById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-修改照片裁剪
export function _editLifeAlbumPhotoCropperUrl(data, dmId) {
  return Service({
    url: urls.editLifeAlbumPhotoCropperUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-取消照片裁剪
export function _cancelLifeAlbumPhotoCropperUrl(data, dmId) {
  return Service({
    url: urls.cancelLifeAlbumPhotoCropperUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-优化照片-AI
export function _editLifeAlbumPhotoAiUrl(data, dmId) {
  return Service({
    url: urls.editLifeAlbumPhotoAiUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-优化照片-AI-确认
export function _confirmLifeAlbumPhotoAiUrl(data, dmId) {
  return Service({
    url: urls.confirmLifeAlbumPhotoAiUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-替换照片-AI
export function _replaceLifeAlbumPhotoAiUrl(data, dmId) {
  return Service({
    url: urls.replaceLifeAlbumPhotoAiUrl,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-替换全部照片-AI
export function _replaceLifeAlbumPhotoAiUrlAll(data, dmId) {
  return Service({
    url: urls.replaceLifeAlbumPhotoAiUrlAll,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-上传视频到纪念堂照片
export function _uploadLifeAlbumVideoToDmPhoto(data, dmId) {
  return Service({
    url: urls.uploadLifeAlbumVideoToDmPhoto,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-下载视频
export function _downloadLifeAlbumVideo(data, dmId) {
  return Service({
    url: urls.downloadLifeAlbumVideo,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-AI照片合成-提取头像
export function _compositeLifeAlbumPhotoAiHeadPic(data, dmId) {
  return Service({
    url: urls.compositeLifeAlbumPhotoAiHeadPic,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-AI照片处理-着色、消除折痕、照片合成
export function _callLifeAlbumPhotoAi(data, dmId) {
  return Service({
    url: urls.callLifeAlbumPhotoAi,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}

//人生相册-上传照片到纪念堂资料
export function _uploadLifeAlbumPhotoToDmPhoto(data, dmId) {
  return Service({
    url: urls.uploadLifeAlbumPhotoToDmPhoto,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId ? dmId : ''
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/Space/index.js